import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { CmsBreadcrumbsComponent, PageMetaService, TranslationService } from '@spartacus/core';
import { BreadcrumbComponent, CmsComponentData, PageLayoutService } from '@spartacus/storefront';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'dp-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DpBreadcrumbComponent extends BreadcrumbComponent implements OnInit, OnDestroy {
  displayTitle: boolean;
  destroy$: Subject<void> = new Subject<void>();

  constructor(
    public component: CmsComponentData<CmsBreadcrumbsComponent>,
    protected pageMetaService: PageMetaService,
    protected translationService: TranslationService,
    private readonly pageLayoutService: PageLayoutService,
  ) {
    super(component, pageMetaService, translationService);
    this.displayTitle = false;
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.pageLayoutService.page$.pipe(takeUntil(this.destroy$)).subscribe((page) => {
      this.displayTitle = page.pageId === 'productList';
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(void 0);
    this.destroy$.complete();
  }
}
